import { normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("button", {
    class: _normalizeClass(["g-transition-plus-button", [{'actived': !_ctx.actived}]]),
    style: _normalizeStyle({ width: _ctx.width + 'px', height: _ctx.width + 'px' })
  }, null, 6))
}